import { render, staticRenderFns } from "./FrzPackingAssembleBins.vue?vue&type=template&id=9a8938fa"
import script from "./FrzPackingAssembleBins.vue?vue&type=script&lang=js"
export * from "./FrzPackingAssembleBins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports